export default function KitsSection() {
  const kits = [
    {
      name: 'Starter Kit',
      price: '1.400.000đ',
      image: 'https://public.readdy.ai/ai/img_res/8b1522b2896d972cc558e6211cf46a88.jpg',
      description: 'Bộ kit nhập môn hoàn hảo cho học sinh THCS, bao gồm các linh kiện cơ bản để xây dựng robot đơn giản',
      includes: [
        'Khung robot cơ bản',
        '2 động cơ DC + bánh xe',
        'Cảm biến siêu âm & hồng ngoại',
        'Board điều khiển Arduino Uno',
        'Tài liệu hướng dẫn chi tiết'
      ]
    },
    {
      name: 'Smart Car Kit',
      price: '1.400.000đ',
      image: 'https://static.readdy.ai/image/5705871e133a048fcd13b20b6e4d74bd/37fad26b2de80feb71b808a2e9b0379c.png',
      description: 'Robot xe thông minh với khả năng dò đường, tránh vật cản và điều khiển từ xa qua Bluetooth',
      includes: [
        'Khung xe robot chuyên dụng',
        '4 động cơ encoder chính xác',
        'Cảm biến dò line + siêu âm',
        'Module Bluetooth HC-05',
        'Pin sạc Lithium 7.4V'
      ]
    },
    {
      name: 'IoT & ESP32 Kit',
      price: '6.500.000đ',
      image: 'https://public.readdy.ai/ai/img_res/81cd5f8858c24a4df1111513414e672e.jpg',
      description: 'Bộ kit IoT đầy đủ để xây dựng các dự án nhà thông minh và kết nối Internet of Things',
      includes: [
        'Board ESP32 WiFi/Bluetooth',
        'Cảm biến nhiệt độ, độ ẩm, ánh sáng',
        'Module relay điều khiển thiết bị',
        'Màn hình OLED hiển thị',
        'Hỗ trợ kết nối Cloud'
      ]
    },
    {
      name: 'AI & Jetson Kit',
      price: '15.000.000đ',
      image: 'https://readdy.ai/api/search-image?query=Advanced%20AI%20robotics%20kit%20with%20Jetson%20Nano%20developer%20board%20and%20camera%20module%20on%20white%20background%2C%20professional%20machine%20learning%20hardware%20kit%20with%20neural%20network%20computing%20platform%20and%20sensors%2C%20high-tech%20AI%20development%20components&width=500&height=400&seq=kit-jetson-004&orientation=squarish',
      description: 'Bộ kit AI cao cấp với Jetson Nano, camera và các module để phát triển ứng dụng trí tuệ nhân tạo',
      includes: [
        'NVIDIA Jetson Nano 4GB',
        'Camera IMX219 8MP',
        'Cảm biến LiDAR & IMU',
        'Khung robot di động',
        'Phần mềm AI & Computer Vision'
      ]
    }
  ];

  return (
    <section id="kits" className="py-20 bg-gradient-to-b from-orange-50 to-white" data-product-shop>
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Robotics <span className="text-orange-600">Kits</span>
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Bộ kit robot chất lượng cao được thiết kế riêng cho từng cấp độ học tập, đầy đủ linh kiện và tài liệu hướng dẫn chi tiết
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {kits.map((kit, index) => (
            <div 
              key={index}
              className="bg-white rounded-xl overflow-hidden shadow-md hover:shadow-2xl transition-all duration-300 border border-gray-100 group"
            >
              <div className="relative h-64 overflow-hidden bg-gray-50">
                <img 
                  alt={kit.name}
                  className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                  src={kit.image}
                />
                <div className="absolute top-4 right-4 bg-orange-600 text-white px-3 py-1 rounded-full font-bold text-sm">
                  {kit.price}
                </div>
              </div>

              <div className="p-6">
                <h3 className="text-xl font-bold text-gray-900 mb-3">{kit.name}</h3>
                <p className="text-sm text-gray-600 mb-4 leading-relaxed">{kit.description}</p>

                <div className="mb-6">
                  <h4 className="font-semibold text-gray-900 mb-3 text-sm flex items-center">
                    <i className="ri-checkbox-circle-line mr-2 text-orange-600"></i>
                    Bao gồm:
                  </h4>
                  <ul className="space-y-2">
                    {kit.includes.map((item, idx) => (
                      <li key={idx} className="flex items-start text-xs text-gray-600">
                        <i className="ri-arrow-right-s-fill text-orange-500 mr-1 mt-0.5 flex-shrink-0"></i>
                        <span>{item}</span>
                      </li>
                    ))}
                  </ul>
                </div>

                <button className="whitespace-nowrap w-full bg-gradient-to-r from-orange-500 to-orange-600 text-white py-3 rounded-lg font-semibold hover:from-orange-600 hover:to-orange-700 transition-all cursor-pointer flex items-center justify-center">
                  <i className="ri-mail-send-line mr-2"></i>
                  Nhận báo giá
                </button>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-12 text-center">
          <p className="text-gray-600 mb-4">
            <i className="ri-information-line text-orange-600 mr-2"></i>
            Tất cả các kit đều được bảo hành 12 tháng và hỗ trợ kỹ thuật trọn đời
          </p>
        </div>
      </div>
    </section>
  );
}